module.exports = __webpack_public_path__ + "img/icon-cardgames-white.d7bf90aa.svg";